import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// FireBase
import * as firebase from "firebase/app";
import "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/functions";
import "firebase/analytics";

import { VLazyImagePlugin } from "v-lazy-image";
Vue.use(VLazyImagePlugin);

import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

// FontAwesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(fas);
Vue.component("font-awesome-icon", FontAwesomeIcon);

// Sentry
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";

import VueTippy from "vue-tippy";
Vue.use(VueTippy, {
  distance: 5,
});

import SVGInjectorVue from "svginjector-vue";

Vue.use(SVGInjectorVue);

Vue.config.productionTip = false;

import PerfectScrollbar from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";

Vue.use(PerfectScrollbar);

import Multiselect from "vue-multiselect";
Vue.component("multiselect", Multiselect);

import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/index.css";

Vue.use(VueToast, {
  position: "top",
  type: "error",
});

import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VueAxios, axios);

import Global from "@/global.js";
Vue.mixin(Global);

const config = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
};

firebase.initializeApp(config);

firebase.analytics();

Sentry.init({
  dsn: "https://172c88c77b4a45c2ad6e7c982a96b21b@sentry.io/2459307",
  integrations: [new Integrations.Vue({ Vue, attachProps: true })],
});

export const db = firebase.firestore();

import { mapState } from "vuex";
new Vue({
  router,
  store,
  computed: {
    ...mapState(["user"]),
    getUser() {
      return this.user ? this.user : "";
    },
  },
  data() {
    return {
      unsubscribeUsers: null,
      unsubscribePrivate: null,
      unsubscribeNotifications: null,
      unsubscribeFriends: null,
      loginFunctionInit: false,
    };
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      store.commit("updateUser", { user });
      // attach listeners
      if (user && !this.listenersActive) {
        this.$attachListeners(user);
      }
      // redirect rules
      if (user) {
        if (
          this.$router.currentRoute.path == "/sign-in" &&
          this.$router.currentRoute.hash !== "#newAccount"
        ) {
          this.$router.replace({ path: "/" });
        }
      }
    });
  },
  watch: {
    $route(to) {
      if (to.name == "dashboard" && this.getUser && !this.loginFunctionInit) {
        this.loginFunction();
      }
    },
  },
  methods: {
    loginFunction() {
      this.loginFunctionInit = true;
      let loginFunction = firebase.functions().httpsCallable("loginFunction");
      loginFunction()
        .then((result) => {
          if (result.data) {
            this.$toast.open({
              message:
                "You have new information in your personality profile since your last visit! Click here to view your profile.",
              duration: 999999999,
              position: "bottom-right",
              dismissible: true,
              type: "info",
              onClose: () => {
                this.$router.replace("results/personality");
              },
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    $attachListeners(user) {
      // Get and watch userdata
      this.unsubscribeUsers = db
        .collection("users")
        .doc(user.uid)
        .onSnapshot(function(doc) {
          const userData = doc.data();
          store.commit("updateUserData", { userData });
        });

      // Get and watch private data
      this.unsubscribePrivate = db
        .collection("users")
        .doc(user.uid)
        .collection("private")
        .doc(user.uid)
        .onSnapshot(function(doc) {
          const userPrivateData = doc.data();
          store.commit("updateUserPrivateData", { userPrivateData });
        });

      // Get and watch notifications
      this.unsubscribeNotifications = db
        .collection("users")
        .doc(user.uid)
        .collection("notifications")
        .orderBy("timestamp", "desc")
        .onSnapshot(function(querySnapshot) {
          var notifications = [];
          querySnapshot.forEach(function(doc) {
            let data = doc.data();
            data.id = doc.id;
            notifications.push(data);
          });
          store.commit("updateNotifications", { notifications });
        });

      // Get and watch friends
      this.unsubscribeFriends = db
        .collection("users")
        .doc(user.uid)
        .collection("friends")
        .onSnapshot(function(querySnapshot) {
          var friends = [];
          querySnapshot.forEach(function(doc) {
            let data = doc.data();
            data.id = doc.id;
            friends.push(data);
          });
          store.commit("updateFriends", { friends });
        });
    },
    $detachListeners() {
      this.unsubscribeUsers(),
        this.unsubscribePrivate(),
        this.unsubscribeNotifications(),
        this.unsubscribeFriends();
    },
    $signOutAndDetachListeners() {
      firebase
        .auth()
        .signOut()
        .then(
          () => {
            this.$detachListeners();
            this.loginFunctionInit = false;
            this.$router.replace("/sign-in");
          },
          (error) => {
            console.error("Sign Out Error", error);
          }
        );
    },
  },
  render: (h) => h(App),
}).$mount("#app");
